const DICT = `/students/settings/`;

const API = {
	DICT
};

export default API;
